import script from "./DrawerBoxEditWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawerBoxEditWrapper.vue?vue&type=script&setup=true&lang=js"

import "./DrawerBoxEditWrapper.vue?vue&type=style&index=0&id=5959a810&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5959a810"]])

export default __exports__